"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var uuid_1 = require("uuid");
var mobx_1 = require("mobx");
var CreatePaymentLine_1 = require("./CreatePaymentLine");
var Discount_1 = require("../Discount");
var Product_1 = require("../Product");
var Category_1 = require("../Category");
var API_1 = require("../../API");
var TaxGroup_1 = require("../TaxGroup");
var Transaction_1 = require("./Transaction");
var _1 = require(".");
var BundleCartDiscountLine_1 = require("../Discount/BundleCartDiscountLine");
var utilities_1 = require("../Discount/utilities");
var discounts_1 = require("../../utilities/discounts");
var CreatePayment = /** @class */ (function () {
    function CreatePayment(companyId, locationId, shiftId, status, pennyRounding) {
        var _this = this;
        this.pennyRounding = true;
        this.isGrowthLoyaltyActive = false;
        this.customerName = null;
        this.locationId = null;
        this.shiftId = null;
        this.refundPaymentId = null;
        /**
         * Use mapped discounts in case of a large list of discounts
         */
        this.mappedDiscounts = new Map();
        this.categories = [];
        this.transactions = [];
        this.completeDate = null;
        this.notes = null;
        this.paymentQueueNotes = null;
        this.employeeId = null;
        this.status = _1.PaymentStatus.COMPLETED;
        this.nonBundleProductLines = [];
        this.bundleCartDiscountLines = [];
        this.nonBundleCartDiscountLines = [];
        this.paymentQueueDiscountIds = new Set();
        this.shouldOverrideDiscountsTimeRestrictions = false;
        this.paymentQueueId = null;
        this.shouldOverrideNonStackingCartDiscountValidation = false;
        this.paymentVerification = null;
        this.addCartDiscountFromQueue = function (queueLine, referenceDiscount) {
            var discountName = referenceDiscount
                ? referenceDiscount.name
                : queueLine.productName;
            var cartDiscountLine;
            if (queueLine.discountPercentage === 0) {
                var discountValue = referenceDiscount
                    ? Math.abs(referenceDiscount.amount) * -1
                    : queueLine.discountPrice;
                cartDiscountLine = _this.addCartFixedDiscount(discountValue, queueLine.discountId, discountName);
            }
            else {
                var discountValue = referenceDiscount
                    ? referenceDiscount.amount
                    : queueLine.discountPercentage;
                cartDiscountLine = _this.addCartPercentDiscount(discountValue, queueLine.discountId, discountName);
            }
            cartDiscountLine.setExternalReward(queueLine.externalReward || undefined);
        };
        this.setRefundLoyaltyPoints = function (refundLoyaltyPoints) {
            _this.refundLoyaltyPoints = refundLoyaltyPoints !== undefined
                ? Math.abs(refundLoyaltyPoints)
                : refundLoyaltyPoints;
        };
        this.populateRefundTransaction = function (paymentTypeId, originalTransaction) {
            var amount = originalTransaction.amount, terminalInvoiceId = originalTransaction.terminalInvoiceId, metadata = originalTransaction.metadata;
            var refundTransaction = Transaction_1.GiftCardPaymentTypeIds.includes(paymentTypeId)
                ? new Transaction_1.CreateGiftCardTransaction(paymentTypeId)
                : new Transaction_1.CreateTransaction(paymentTypeId);
            refundTransaction.setRefundTerminalInvoiceId(terminalInvoiceId);
            refundTransaction.setMetadata(metadata);
            if (refundTransaction instanceof Transaction_1.CreateGiftCardTransaction) {
                refundTransaction.setReferenceNumberFromMetaData(metadata);
                refundTransaction.setRedeemableAmount(amount);
                refundTransaction.setCardNumberFromMetaData(metadata);
                refundTransaction.setTransactionIdFromMetaData(metadata);
            }
            return refundTransaction;
        };
        this.getDiscount = function (discountId) { return _this.mappedDiscounts.get(discountId); };
        this.addAutomaticProductDiscounts = function () {
            _this.nonBundledProductPaymentLines.forEach(function (paymentLine) {
                _this.applyAvailableProductDiscount(paymentLine);
            });
        };
        this.createPaymentLine = function (params, giftCardParams) {
            var product = params.product, pricePerInventorySubtracted = params.pricePerInventorySubtracted, inventoryToSubtract = params.inventoryToSubtract, inventorySubtractIncrement = params.inventorySubtractIncrement, maximumQuantity = params.maximumQuantity, barcode = params.barcode, batchId = params.batchId, batchNumber = params.batchNumber, scannedBy = params.scannedBy;
            var paymentLine = product.isGiftCard
                ? new CreatePaymentLine_1.CreateGiftCardPaymentLine(_this, _1.PaymentLineType.PRODUCT)
                : new CreatePaymentLine_1.CreatePaymentLine(_this, product.productType === Product_1.ProductType.PAYMENT_FEE ? _1.PaymentLineType.PAYMENT_FEE : _1.PaymentLineType.PRODUCT);
            if (paymentLine instanceof CreatePaymentLine_1.CreateGiftCardPaymentLine) {
                paymentLine.populateGiftCardParams(giftCardParams);
            }
            if (inventorySubtractIncrement) {
                product.inventorySubtractAmount = inventorySubtractIncrement;
            }
            paymentLine.product = product;
            paymentLine.unit = product.unit;
            paymentLine.productId = product.id;
            paymentLine.categoryId = product.categoryId;
            paymentLine.parentCategoryId = product.parentCategoryId;
            paymentLine.complianceCategoryId = product.complianceCategoryId;
            paymentLine.barcode = barcode || null;
            paymentLine.maximumQuantity = maximumQuantity;
            paymentLine.shortDescription = product.shortDescription;
            paymentLine.batchId = batchId || null;
            paymentLine.batchNumber = batchNumber;
            paymentLine.sku = product.sku;
            paymentLine.setScannedBy(scannedBy);
            // Product is probably tracked in bulk - don't include variant name
            var name;
            if (product.parentProductId && product.trackInventory === false) {
                name = product.parentProductName;
            }
            else {
                name = product.parentProductName ? product.parentProductName + " - " + product.name : product.name;
            }
            paymentLine.productName = name;
            paymentLine.setPricePerInventorySubtracted(pricePerInventorySubtracted);
            paymentLine.setInventorySubtracted(inventoryToSubtract);
            return paymentLine;
        };
        this.applyAvailableProductDiscount = function (paymentLine) {
            if (paymentLine.hasNonAutomaticDiscount || paymentLine.autoDiscountDismissed) {
                return;
            }
            var autoDiscounts = _this.availableProductDiscounts(paymentLine.productId, paymentLine.categoryId, true);
            var discount = discounts_1.getBestAutomaticDiscount(paymentLine.pricePerUnit, autoDiscounts);
            if (discount) {
                if (discount.type === 'percent') {
                    paymentLine.addPercentDiscount(discount.amount, discount.id, discount.name);
                }
                else if (discount.type === 'fixed') {
                    paymentLine.addFixedDiscount(discount.amount, discount.id, discount.name);
                }
            }
        };
        this.removePaymentLine = function (index) {
            var paymentLine = _this.paymentLines[index];
            var bundleDiscountLine = paymentLine.bundleDiscountLine;
            if (bundleDiscountLine) {
                // Bundle discounted payment lines can only be removed by removing its bundle discount
                var i = _this.bundleCartDiscountLines.findIndex(function (bdl) { return bdl.discountId === bundleDiscountLine.discountId; });
                _this.removeBundleCartDiscount([i]);
            }
            else {
                _this.nonBundleProductLines.splice(index, 1);
            }
        };
        this.removeBundleCartDiscount = function (indexes) {
            if (indexes.length > 0) {
                _this.bundleCartDiscountLines = _this.bundleCartDiscountLines.filter(function (_, index) { return !indexes.includes(index); });
            }
        };
        this.removeNonBundleCartDiscount = function (indexes) {
            if (indexes.length > 0) {
                _this.nonBundleCartDiscountLines = _this.nonBundleCartDiscountLines.filter(function (_, index) { return !indexes.includes(index); });
            }
            _this.cartDiscountLinesObserver = mobx_1.observe(_this.nonBundleCartDiscountLines, _this.cartDiscountLineListener);
            _this.cartDiscountLineListener();
        };
        this.addBundleDiscount = function (params) {
            var bundleDiscountLine = new BundleCartDiscountLine_1.BundleCartDiscountLine(params);
            _this.bundleCartDiscountLines.push(bundleDiscountLine);
            var paymentLineKey = function (paymentLine) { return (paymentLine.product && paymentLine.product.isBatchTracked
                ? paymentLine.productId + "///" + paymentLine.batchId + "}"
                : paymentLine.productId); };
            var bundleProductIds = new Map(bundleDiscountLine.paymentLines.map(function (pl) { return [paymentLineKey(pl), pl]; }));
            /**
             * We subtract the bundle-discounted quantities off from the non-bundle discounted payment lines.
             * Check if `batchId` is also identical if product is batch-tracked
             */
            _this.nonBundleProductLines.forEach(function (ipl) {
                var key = paymentLineKey(ipl);
                if (bundleProductIds.get(key)) {
                    ipl.setInventorySubtracted(ipl.inventorySubtracted - bundleDiscountLine.targetMinUnitSold);
                }
            });
            _this.nonBundleProductLines = _this.nonBundleProductLines.filter(function (pl) { return pl.inventorySubtracted !== 0; });
            _this.nonBundleCartDiscountLines.forEach(function (cdl) { return cdl.setPaymentLines(_this.nonBundleProductLines); });
            _this.paymentLinesObserver = mobx_1.observe(_this.nonBundleProductLines, _this.paymentLineListener);
            _this.cartDiscountLinesObserver = mobx_1.observe(_this.nonBundleCartDiscountLines, _this.cartDiscountLineListener);
            return bundleDiscountLine;
        };
        this.removeUnusedNonStackableCartDiscounts = function () {
            if (_this.shouldOverrideNonStackingCartDiscountValidation)
                return;
            _this.nonBundleCartDiscountLines = _this.nonBundleCartDiscountLines.filter(function (cdl) {
                var isNonStackableDiscount = cdl.referenceDiscount && cdl.referenceDiscount.isStackable === false;
                var hasNoDiscountApplied = cdl.discountPrice === 0;
                return !(isNonStackableDiscount && hasNoDiscountApplied);
            });
            _this.cartDiscountLinesObserver = mobx_1.observe(_this.nonBundleCartDiscountLines, _this.cartDiscountLineListener);
        };
        this.updateCartDiscounts = function () {
            _this.removeUnusedNonStackableCartDiscounts();
            _this.nonBundleCartDiscountLines.forEach(function (cdl) {
                var isNonStackableDiscount = !_this.shouldOverrideNonStackingCartDiscountValidation && cdl.referenceDiscount && cdl.referenceDiscount.isStackable === false;
                if (isNonStackableDiscount) {
                    var allProductPaymentLinesWithNoDiscount = _this.nonBundleProductLines.filter(function (pl) { return pl.discountPrice === 0; });
                    cdl.setPaymentLines(allProductPaymentLinesWithNoDiscount);
                }
                else {
                    cdl.setPaymentLines(_this.nonBundleProductLines);
                }
                cdl.discountType === Discount_1.DiscountTypes.PERCENT
                    ? _this.updatePercentageCartDiscount(cdl)
                    : _this.updateFixedCartDiscount(cdl);
            });
        };
        this.updatePercentageCartDiscount = function (cdl) {
            var updatedDiscountPrice = Math.abs(_this.calculatePercentageDiscount(cdl.discountPercentage, cdl)) * -1;
            var discountedProductTotal = _this.getSumOfDiscountedLinePricesMinusFixedCartDiscounts(cdl);
            var minAllowableCannabisDiscountedPrice = 1 * _this.getTotalCannabisItemCount(cdl.includedPaymentLines); // Each cannabis product must be sold at $0.01 or greater
            var isDiscountedPriceBelowMinimum = updatedDiscountPrice + discountedProductTotal < minAllowableCannabisDiscountedPrice;
            if (isDiscountedPriceBelowMinimum) {
                // If total is already below minimum price before applying the current discount, don't add extra discount
                var isTotalBelowMininumPrice = discountedProductTotal - minAllowableCannabisDiscountedPrice < 0;
                updatedDiscountPrice = isTotalBelowMininumPrice ? 0 : Math.abs(discountedProductTotal - minAllowableCannabisDiscountedPrice) * -1; // Add discount only when total is greater than minimum price
            }
            cdl.setDiscountPrice(updatedDiscountPrice);
        };
        this.updateFixedCartDiscount = function (cdl) {
            var adjustedCartDiscountAmount = _this.adjustCartDiscountAmount(cdl.originalDiscountPrice, cdl);
            cdl.setDiscountPrice(adjustedCartDiscountAmount);
        };
        /**
         * Amount of total completed transactions from original payment
         */
        this.originalPendingRefundPaymentTotal = 0;
        this.adjustCartDiscountAmount = function (centValue, cdl, isStackable) {
            var sumOfDiscountedLinePricesMinusFixedCartDiscounts = _this.getSumOfDiscountedLinePricesMinusFixedCartDiscounts(cdl, isStackable);
            if (cdl && cdl.includedPaymentLines.length > 0) {
                sumOfDiscountedLinePricesMinusFixedCartDiscounts += Math.abs(cdl.discountPrice);
            }
            var isDiscountAmountValid = Math.abs(sumOfDiscountedLinePricesMinusFixedCartDiscounts) > Math.abs(centValue);
            if (isDiscountAmountValid) {
                return Math.abs(centValue) * -1;
            }
            // Each cannabis product must be sold at $0.01 or greater
            var minAllowableCannabisDiscountedPrice = cdl
                ? _this.getTotalCannabisItemCount(cdl.includedPaymentLines)
                : 0;
            var amountRequiredUntilMinimumPrice = minAllowableCannabisDiscountedPrice - sumOfDiscountedLinePricesMinusFixedCartDiscounts;
            return Math.abs(amountRequiredUntilMinimumPrice) * -1;
        };
        this.getSumOfDiscountedLinePricesMinusFixedCartDiscounts = function (cdl, isStackable) {
            var paymentLines = cdl ? cdl.includedPaymentLines : _this.allProductPaymentLines;
            var sumOfDiscountedLinePrices;
            var isCdlDiscountNonStackable = !_this.shouldOverrideNonStackingCartDiscountValidation && cdl && cdl.referenceDiscount && cdl.referenceDiscount.isStackable === false;
            if (isStackable === false || isCdlDiscountNonStackable) {
                sumOfDiscountedLinePrices = paymentLines.reduce(function (acc, pl) { return (pl.discountPrice === 0 ? acc + pl.productLineDiscountedPrice : acc + pl.price); }, 0);
            }
            else {
                sumOfDiscountedLinePrices = paymentLines.reduce(function (acc, pl) { return acc + pl.productLineDiscountedPrice; }, 0);
            }
            var fixedCartDiscountLines = cdl ? _this.getFixedCartDiscountLines(cdl.includedPaymentLines) : _this.fixedCartDiscountLines;
            var sumOfFixedCartDiscounts = fixedCartDiscountLines.reduce(function (acc, curr) { return acc + curr.discountPrice; }, 0);
            var sumOfLoyaltyDiscounts = _this.getSumOfLoyaltyDiscounts();
            return Math.round(sumOfDiscountedLinePrices + sumOfFixedCartDiscounts + sumOfLoyaltyDiscounts);
        };
        this.paymentLineListener = function () {
            _this.nonBundleCartDiscountLines.forEach(function (cdl) { return cdl.setPaymentLines(_this.nonBundleProductLines); });
            var paymentLinesMap = new Map(_this.allProductPaymentLines.map(function (pl) { return [pl.productId, pl]; }));
            var bundleIndexes = [];
            _this.bundleCartDiscountLines.forEach(function (bcdl, index) {
                var shouldRemove = _this.shouldRemoveCartDiscountOnProductChange(paymentLinesMap, bcdl);
                if (shouldRemove)
                    bundleIndexes.push(index);
            });
            _this.removeBundleCartDiscount(bundleIndexes);
            var nonBundleIndexes = [];
            _this.nonBundleCartDiscountLines.forEach(function (cdl, index) {
                var shouldRemove = _this.shouldRemoveCartDiscountOnProductChange(paymentLinesMap, cdl);
                if (shouldRemove)
                    nonBundleIndexes.push(index);
            });
            _this.removeNonBundleCartDiscount(nonBundleIndexes);
            _this.updateCartDiscounts();
        };
        this.shouldRemoveCartDiscountOnProductChange = function (paymentLinesMap, cdl) {
            var e_1, _a;
            var shouldRemove = false;
            // get the actual discount. If for whatever reason there's no id or the discount isn't in the map, leave the cdl as is
            if (!cdl.discountId)
                return;
            var discount = _this.getDiscount(cdl.discountId);
            if (!discount)
                return;
            // if it's not a cart discount, skip it
            if (discount.applyType !== 'cart')
                return;
            // if the discount has no products attached for whatever reason, skip it
            if (discount.products.length === 0)
                return;
            // if it's not an include cart discount, skip it
            if (discount.products[0].type !== 'include')
                return;
            try {
                for (var _b = __values(discount.products), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var discountProduct = _c.value;
                    var paymentLine = paymentLinesMap.get(discountProduct.id);
                    if (paymentLine === undefined) {
                        shouldRemove = true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return shouldRemove;
        };
        this.cartDiscountLineListener = function () {
            _this.updateCartDiscounts();
        };
        this.canAddCartDiscount = function (discount) {
            if (_this.shouldOverrideNonStackingCartDiscountValidation)
                return true;
            if (_this.hasNonStackableCartDiscount)
                return false;
            var discountId = discount.id;
            var discountToApply = _this.getDiscount(discountId);
            if (!discountToApply)
                return false;
            if (!discountToApply.isStackable && _this.nonBundleCartDiscountLines.length > 0) {
                return false;
            }
            return true;
        };
        this.canAddDiscount = function (discount) {
            if (!discount) {
                return !_this.hasNonStackableCartDiscount;
            }
            switch (discount.applyType) {
                case Discount_1.ApplyTypes.CART:
                    return _this.canAddCartDiscount(discount);
                default:
                    return true;
            }
        };
        this.calculatePercentageDiscount = function (percent, cdl, isStackable) {
            percent = Math.abs(percent);
            var discountedLineSubTotal = cdl
                ? _this.getSumOfDiscountedPricesByIncludedCartDiscount(cdl)
                : _this.getSumOfNonBundledLineDiscountedProductPrices();
            var sumOfFixedCartDiscounts = _this.fixedCartDiscountLines.reduce(function (acc, curr) { return acc + curr.discountPrice; }, 0);
            var cartSubtotal = discountedLineSubTotal + sumOfFixedCartDiscounts;
            var isCdlDiscountNonStackable = cdl && cdl.referenceDiscount && cdl.referenceDiscount.isStackable === false;
            if (!_this.shouldOverrideNonStackingCartDiscountValidation && (isStackable === false || isCdlDiscountNonStackable)) {
                var sumOfAllLinesWithProductDiscount = void 0;
                if (cdl) {
                    sumOfAllLinesWithProductDiscount = cdl.includedPaymentLines.reduce(function (acc, curr) { return acc + (curr.discountPrice < 0 ? curr.productLineDiscountedPrice : 0); }, 0);
                }
                else {
                    sumOfAllLinesWithProductDiscount = _this.nonBundledProductPaymentLines.reduce(function (acc, curr) { return acc + (curr.discountPrice < 0 ? curr.productLineDiscountedPrice : 0); }, 0);
                }
                cartSubtotal = cartSubtotal - sumOfAllLinesWithProductDiscount;
            }
            return cartSubtotal > 0
                ? Math.round(cartSubtotal * (percent / 100))
                : 0;
        };
        this.getSumOfDiscountedPricesByIncludedCartDiscount = function (cdl) { return cdl.includedPaymentLines.reduce(function (acc, pl) { return acc + (pl.price + pl.discountPrice); }, 0); };
        this.getSumOfNonBundledLineDiscountedProductPrices = function () { return _this.nonBundledProductPaymentLines.reduce(function (acc, curr) { return acc + curr.productLineDiscountedPrice; }, 0); };
        this.getSumOfLoyaltyDiscounts = function () { return _this.loyaltyPaymentLines.reduce(function (acc, curr) { return acc + curr.discountPrice; }, 0); };
        this.setOverridenManager = function (overridenManager) {
            _this.overridenManager = overridenManager;
        };
        this.setExternalCustomerLoyaltyTierId = function (externalCustomerLoyaltyTierId) {
            _this.externalCustomerLoyaltyTierId = externalCustomerLoyaltyTierId;
        };
        this.setIsGrowthLoyaltyActive = function (isGrowthLoyaltyActive) {
            _this.isGrowthLoyaltyActive = isGrowthLoyaltyActive;
        };
        this.setPaymentQueueDiscountIds = function (paymentQueueLines) {
            paymentQueueLines.forEach(function (line) {
                if (line.discountId) {
                    _this.paymentQueueDiscountIds.add(line.discountId);
                }
            });
        };
        this.setTimezone = function (timezone) {
            _this.timezone = timezone;
        };
        this.setShouldOverrideDiscountsTimeRestrictions = function (shouldOverride) {
            _this.shouldOverrideDiscountsTimeRestrictions = shouldOverride;
        };
        this.setShouldOverrideNonStackingCartDiscountValidation = function (shouldOverride) {
            _this.shouldOverrideNonStackingCartDiscountValidation = shouldOverride;
        };
        this.setPaymentVerification = function (paymentVerification) {
            _this.paymentVerification = paymentVerification;
        };
        this.companyId = companyId;
        this.offlinePaymentId = uuid_1.v4();
        if (!lodash_1.isNil(locationId)) {
            this.locationId = locationId;
        }
        if (!lodash_1.isNil(shiftId)) {
            this.shiftId = shiftId;
        }
        if (!lodash_1.isNil(pennyRounding)) {
            this.pennyRounding = pennyRounding;
        }
        var allowedPaymentStatus = [_1.PaymentStatus.PENDING, _1.PaymentStatus.INPROGRESS, _1.PaymentStatus.COMPLETED];
        if (status && allowedPaymentStatus.includes(status)) {
            this.status = status;
        }
        this.paymentLinesObserver = mobx_1.observe(this.nonBundleProductLines, this.paymentLineListener);
        this.cartDiscountLinesObserver = mobx_1.observe(this.nonBundleCartDiscountLines, this.cartDiscountLineListener);
    }
    Object.defineProperty(CreatePayment.prototype, "discounts", {
        get: function () {
            return __spread(this.mappedDiscounts.values());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "paymentLines", {
        get: function () {
            var bundleProductLines = this.bundleCartDiscountLines.reduce(function (acc, bdl) { return __spread(acc, bdl.paymentLines); }, []);
            return __spread(this.nonBundleProductLines, bundleProductLines);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "cartDiscountLines", {
        get: function () {
            return __spread(this.bundleCartDiscountLines, this.nonBundleCartDiscountLines);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "loyaltyCartDiscountPoints", {
        get: function () {
            return this.cartDiscountLines.reduce(function (acc, line) { return acc + (line.loyaltyCost || 0); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "loyaltyProductDiscountPoints", {
        get: function () {
            return this.paymentLines.reduce(function (acc, line) { return acc + (line.loyaltyCost || 0); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "loyaltyDiscountPoints", {
        get: function () {
            return this.loyaltyCartDiscountPoints + this.loyaltyProductDiscountPoints;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "loyaltyTransactionPoints", {
        get: function () {
            return this.transactions.reduce(function (acc, transaction) {
                if (transaction.paymentTypeId === Transaction_1.PaymentTypeIds.loyalty) {
                    var loyaltyPoints = transaction.metadata ? JSON.parse(transaction.metadata).points : 0;
                    return acc + loyaltyPoints;
                }
                return acc;
            }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "sumOfLoyaltyPointsUsed", {
        get: function () {
            return this.loyaltyDiscountPoints + this.loyaltyTransactionPoints;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "remainingLoyaltyPoints", {
        get: function () {
            if (!this.customer) {
                return 0;
            }
            return this.customer.creditBalance - this.sumOfLoyaltyPointsUsed;
        },
        enumerable: true,
        configurable: true
    });
    CreatePayment.prototype.setPaymentLineChangeCallback = function (cb) {
        this.paymentLineChangeCallback = cb;
    };
    CreatePayment.prototype.setShiftId = function (shiftId) {
        this.shiftId = shiftId;
    };
    CreatePayment.prototype.populateFromQueue = function (queue, posListings, setQueueDiscounts) {
        if (setQueueDiscounts === void 0) { setQueueDiscounts = true; }
        return __awaiter(this, void 0, void 0, function () {
            var customerById, nonBundledCartDiscounts, bundleDiscountLines, bundleDiscountProductIds, isExternalOrder;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.paymentQueueId = queue.id;
                        this.paymentQueueNotes = queue.notes;
                        this.setOfflinePaymentId(queue.offlinePaymentId || this.offlinePaymentId);
                        if (setQueueDiscounts)
                            this.setPaymentQueueDiscountIds(queue.paymentLines);
                        if (!(queue.customerId && !this.customerWithHistory)) return [3 /*break*/, 2];
                        return [4 /*yield*/, API_1.API.getCustomerById(this.companyId, queue.customerId)];
                    case 1:
                        customerById = _a.sent();
                        if (customerById)
                            this.addCustomer(customerById);
                        return [3 /*break*/, 3];
                    case 2:
                        this.customerName = queue.customerName;
                        _a.label = 3;
                    case 3:
                        nonBundledCartDiscounts = [];
                        bundleDiscountLines = [];
                        queue.paymentLines.forEach(function (queueLine) {
                            var referenceDiscount = queueLine.discountId === null
                                ? undefined
                                : _this.getDiscount(queueLine.discountId);
                            /**
                             * A cart discount is capped to what the cart can absorb, so one applied to an empty cart is
                             * parked with a 0 amount. The amount alone therefore cannot tell a cart discount apart from
                             * the other line without a product - a loyalty credit - which always carries an amount.
                             */
                            var isCartDiscount = !queueLine.productId
                                && (queueLine.discountPrice !== 0
                                    || queueLine.discountPercentage !== 0
                                    || !!queueLine.externalReward);
                            if (!isCartDiscount) {
                                return;
                            }
                            if (referenceDiscount && utilities_1.isBundleDiscount(referenceDiscount)) {
                                bundleDiscountLines.push({ queueLine: queueLine, referenceDiscount: referenceDiscount });
                                return;
                            }
                            nonBundledCartDiscounts.push({ queueLine: queueLine, referenceDiscount: referenceDiscount });
                        });
                        bundleDiscountLines = bundleDiscountLines.sort(function (a, b) { return b.referenceDiscount.products.length - a.referenceDiscount.products.length; });
                        bundleDiscountProductIds = bundleDiscountLines.reduce(function (acc, bdl) { return __spread(acc, bdl.referenceDiscount.products.map(function (p) { return p.id; })); }, []);
                        isExternalOrder = !!queue.externalSourceName;
                        queue.paymentLines.forEach(function (queueLine) {
                            var createdPaymentLine;
                            // Handle products
                            if (queueLine.productId) {
                                var isBundleDiscountProduct = bundleDiscountProductIds.includes(queueLine.productId);
                                // productId exists
                                var posListing_1 = posListings.find(function (listing) { return listing.id === queueLine.productId; });
                                var parentPosListing = posListings.find(function (posListing) { return !!posListing.childProducts.find(function (childProduct) { return childProduct.id === queueLine.productId; }); });
                                if (posListing_1) {
                                    /**
                                     * Priority order
                                     * 1. Try using `price` from posListing first.
                                     * 2. If posListing.price is null (i.e. fee product), use queueLine.price / quantity (pricePerQuantity)
                                     * 3. Fall back on 0
                                     */
                                    var price = posListing_1.price
                                        || ((queueLine.price || 0) / queueLine.quantity)
                                        || 0;
                                    var pricePerInventorySubtracted = price / (posListing_1.inventorySubtractAmount || 1);
                                    if (parentPosListing) {
                                        /*
                                          Variant product section
                                        */
                                        createdPaymentLine = _this.addToCart({
                                            product: posListing_1,
                                            pricePerInventorySubtracted: pricePerInventorySubtracted,
                                            inventoryToSubtract: queueLine.quantity,
                                            barcode: queueLine.barcode,
                                            maximumQuantity: posListing_1.quantity,
                                            scannedBy: queueLine.scannedBy || null,
                                        }, isBundleDiscountProduct, undefined, isExternalOrder);
                                    }
                                    else if (posListing_1.isMasterProduct) {
                                        /*
                                          Bulk product section
                                            - this should have bulkPricePerInventorySubtracted property to use. If not, just use pricePerInventorySubtracted from the above.
                                        */
                                        var bulkPricePerInventorySubtractedToUse = queueLine.bulkPricePerInventorySubtracted || pricePerInventorySubtracted;
                                        createdPaymentLine = _this.addToCart({
                                            product: posListing_1,
                                            pricePerInventorySubtracted: bulkPricePerInventorySubtractedToUse,
                                            inventoryToSubtract: queueLine.quantity,
                                            barcode: queueLine.barcode,
                                            maximumQuantity: posListing_1.quantity,
                                            scannedBy: queueLine.scannedBy || null,
                                        }, isBundleDiscountProduct, undefined, isExternalOrder);
                                        // Once added to cart, update bulkPricePerInventorySubtracted, in case user 'parks' the payment again
                                        var existingPaymentLine = _this.nonBundleProductLines.find(function (paymentLine) { return paymentLine.productId === posListing_1.id; });
                                        existingPaymentLine.setBulkPricePerInventorySubtracted(bulkPricePerInventorySubtractedToUse);
                                    }
                                    else {
                                        // Standalone
                                        createdPaymentLine = _this.addToCart({
                                            product: posListing_1,
                                            pricePerInventorySubtracted: price,
                                            inventoryToSubtract: queueLine.quantity,
                                            barcode: queueLine.barcode,
                                            maximumQuantity: posListing_1.quantity,
                                            scannedBy: queueLine.scannedBy || null,
                                        }, isBundleDiscountProduct, undefined, isExternalOrder);
                                    }
                                }
                            }
                            // Handle discounts
                            // Need to add products to cart first to attach discounts to products
                            if (queueLine.productId && queueLine.discountPrice) {
                                if (createdPaymentLine) {
                                    queueLine.discountPercentage !== 0
                                        ? createdPaymentLine.addPercentDiscount(queueLine.discountPercentage, queueLine.discountId, queueLine.discountMessage || '')
                                        : createdPaymentLine.addFixedDiscount(Math.round(queueLine.discountPrice / queueLine.quantity) * -1, queueLine.discountId, queueLine.discountMessage || '');
                                    createdPaymentLine.setExternalReward(queueLine.externalReward || undefined);
                                }
                            }
                        });
                        bundleDiscountLines.forEach(function (_a) {
                            var queueLine = _a.queueLine, referenceDiscount = _a.referenceDiscount;
                            _this.addCartDiscountFromQueue(queueLine, referenceDiscount);
                        });
                        nonBundledCartDiscounts.forEach(function (_a) {
                            var queueLine = _a.queueLine, referenceDiscount = _a.referenceDiscount;
                            _this.addCartDiscountFromQueue(queueLine, referenceDiscount);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreatePayment.prototype.addToCart = function (params, isBundleDiscounted, giftCardParams, isExternalOrder) {
        if (isBundleDiscounted === void 0) { isBundleDiscounted = undefined; }
        var existingPaymentLines = this.nonBundleProductLines.filter(function (paymentLine) { return paymentLine.productId === params.product.id; });
        var existingPaymentLine = existingPaymentLines.find(function (paymentLine) {
            var product = paymentLine.product;
            switch (true) {
                case product === undefined:
                    return false;
                case isBundleDiscounted:
                    return true;
                case product.isBatchTracked:
                    return paymentLine.batchId === params.batchId;
                default:
                    return true;
            }
        });
        if (existingPaymentLine
            && existingPaymentLine.product
            && !existingPaymentLine.product.inBetweenPricing
            && !params.product.isGiftCard) {
            existingPaymentLine.setInventorySubtracted(existingPaymentLine.inventorySubtracted + params.inventoryToSubtract);
            return existingPaymentLine;
        }
        var newPaymentLine = this.addProduct(params, giftCardParams, isExternalOrder);
        return newPaymentLine;
    };
    // Used for refunding sales - fill in negative versions of the passed-in sale
    CreatePayment.prototype.populateRefund = function (payment) {
        var _this = this;
        this.refundPaymentId = payment.id;
        if (payment.customerId) {
            // Use dummy customer
            this.addCustomer({
                customer: {
                    id: payment.customerId,
                    name: payment.customerName,
                    secureProfileImageFileName: null,
                    idType: null,
                    secureIdImageFileName: null,
                    cardId: null,
                    companyId: null,
                    email: null,
                    canContactEmail: false,
                    phone: null,
                    canContactPhone: false,
                    city: null,
                    province: null,
                    address: null,
                    country: null,
                    postalCode: null,
                    driversLicenseNumber: null,
                    passportNumber: null,
                    notes: null,
                    loyaltyTierId: null,
                    loyaltyTierName: null,
                    createDate: new Date(),
                    totalSpend: 0,
                    creditBalance: 0,
                    birthday: null,
                    expiryDate: null,
                    isDeleted: false,
                    locationId: null,
                    locationName: null,
                    gender: null,
                    isTaxExempt: false,
                },
                statistics: {
                    lastPurchase: null,
                    totalSpend: 0,
                },
            });
        }
        payment.paymentLines.forEach(function (paymentLine) {
            if (paymentLine.sku && paymentLine.sku.trim() === 'tip')
                return;
            if (paymentLine.type === _1.PaymentLineType.PAYMENT_FEE)
                return;
            if (paymentLine.productId) {
                var totalEffectivePrice_1 = paymentLine.price + paymentLine.discountPrice + paymentLine.cartDiscountPrice;
                var matchingTaxPaymentLines_1 = payment.taxPaymentLines.filter(function (taxPaymentLine) { return taxPaymentLine.paymentLineId === paymentLine.id; });
                var inventorySubtracted = paymentLine.inventorySubtracted === null ? paymentLine.units : paymentLine.inventorySubtracted;
                var depositFeePerInventorySubtracted = paymentLine.depositFee ? paymentLine.depositFee / inventorySubtracted : null;
                _this.addProduct({
                    product: {
                        id: paymentLine.productId,
                        parentProductId: null,
                        name: paymentLine.productName,
                        parentProductName: null,
                        categoryId: null,
                        parentCategoryId: null,
                        complianceCategoryId: null,
                        unit: paymentLine.unit || 'unit',
                        inventorySubtractAmount: 1,
                        cannabisWeight: null,
                        sku: paymentLine.sku,
                        shortDescription: paymentLine.shortDescription,
                        depositFee: depositFeePerInventorySubtracted,
                        price: null,
                        taxes: matchingTaxPaymentLines_1.map(function (taxPaymentLine) {
                            var taxAmount = taxPaymentLine.amount;
                            // Consider the BC vape tax
                            var vapeTaxId = TaxGroup_1.TaxIDs['Vape PST (BC)'];
                            var matchingBCVapeTax = matchingTaxPaymentLines_1.find(function (tax) { return tax.taxId === vapeTaxId; });
                            var bcVapeTaxAmount = matchingBCVapeTax ? matchingBCVapeTax.amount : 0;
                            // Calculate the final %
                            var isVapeTax = taxPaymentLine.taxId === vapeTaxId;
                            var percent;
                            if (totalEffectivePrice_1 === 0) {
                                percent = 0;
                            }
                            else {
                                percent = isVapeTax
                                    ? (taxAmount / totalEffectivePrice_1 * 100)
                                    : (taxAmount / (totalEffectivePrice_1 + bcVapeTaxAmount) * 100);
                            }
                            return {
                                id: taxPaymentLine.taxId,
                                name: taxPaymentLine.taxName,
                                percent: percent,
                                exemptOverride: taxPaymentLine.exemptOverride,
                            };
                        }),
                        trackInventory: true,
                        inBetweenPricing: false,
                        isBatchTracked: paymentLine.batchId !== null,
                        isGiftCard: paymentLine.isGiftCard,
                        productType: null,
                    },
                    pricePerInventorySubtracted: inventorySubtracted === 0 ? 0 : totalEffectivePrice_1 / inventorySubtracted,
                    inventoryToSubtract: inventorySubtracted * -1,
                    barcode: null,
                    maximumQuantity: null,
                    batchId: paymentLine.batchId || undefined,
                    batchNumber: paymentLine.batchNumber || undefined,
                    scannedBy: paymentLine.scannedBy || null,
                });
            }
            else {
                // Don't add discount lines, keep things simple. Cart discount prices are factored into products
            }
        });
        payment.transactions.forEach(function (transaction) {
            var refundTransaction = _this.populateRefundTransaction(transaction.paymentTypeId, transaction);
            _this.addTransaction(refundTransaction);
        });
        // Default to return stock
        this.setAdjustInventory(true);
        var pendingTransactions = payment.transactions.filter(function (trans) { return trans.status === Transaction_1.TransactionStatus.PENDING; });
        var pendingTransactionsTotal = pendingTransactions.reduce(function (acc, cur) { return acc + cur.amount; }, 0);
        this.originalPendingRefundPaymentTotal = pendingTransactionsTotal;
    };
    /** Used to remove transactions with 0 amount. Useful for refunds due to transactions array often larger than needed */
    CreatePayment.prototype.removeEmptyTransactions = function () {
        this.transactions = this.transactions.filter(function (transaction) { return transaction.amount !== 0; });
    };
    CreatePayment.prototype.setDiscounts = function (discounts) {
        var _this = this;
        this.mappedDiscounts.clear();
        discounts.forEach(function (discount) { return _this.mappedDiscounts.set(discount.id, discount); });
        this.nonBundleProductLines.forEach(function (paymentLine) {
            if (paymentLine.discountId && !_this.mappedDiscounts.has(paymentLine.discountId) && !_this.paymentQueueDiscountIds.has(paymentLine.discountId)) {
                paymentLine.removeDiscount();
            }
        });
    };
    CreatePayment.prototype.setCategories = function (categories) {
        this.categories = categories;
    };
    CreatePayment.prototype.setNotes = function (notes) {
        this.notes = notes || null;
    };
    CreatePayment.prototype.setPaymentQueueNotes = function (notes) {
        this.paymentQueueNotes = notes || null;
    };
    CreatePayment.prototype.addProductDiscountsOnAddCustomer = function (customerWithHistory) {
        var _a = customerWithHistory.customer, loyaltyTierId = _a.loyaltyTierId, loyaltyTierName = _a.loyaltyTierName;
        if (loyaltyTierId && loyaltyTierName) {
            this.addAutomaticProductDiscounts();
        }
    };
    CreatePayment.prototype.addCustomer = function (customerWithHistory) {
        this.customerWithHistory = customerWithHistory;
        this.addProductDiscountsOnAddCustomer(customerWithHistory);
    };
    CreatePayment.prototype.removeCustomer = function () {
        this.customerWithHistory = undefined;
        this.customerName = null;
        var loyaltyTransactionIndex = this.transactions.findIndex(function (transaction) { return transaction.paymentTypeId === Transaction_1.PaymentTypeIds.loyalty; });
        if (loyaltyTransactionIndex !== -1) {
            this.removeTransactionAtIndex(loyaltyTransactionIndex);
        }
        if (this.hasLoyalty) {
            var loyaltyPaymentLineIndex = this.nonBundleProductLines.findIndex(function (pl) { return pl.type === 'loyalty'; });
            this.nonBundleProductLines.splice(loyaltyPaymentLineIndex, 1);
        }
        var mappedAvailableLoyaltyDiscounts = this.mappedAvailableLoyaltyDiscounts;
        // remove loyalty product discounts from each paymentLine
        this.nonBundleProductLines.forEach(function (line) {
            var loyaltyDiscount = line.discountId ? mappedAvailableLoyaltyDiscounts.get(line.discountId) : undefined;
            if (loyaltyDiscount) {
                line.removeDiscount();
            }
        });
        // remove loyalty cart discounts from cartDiscountLine
        this.nonBundleCartDiscountLines = this.nonBundleCartDiscountLines.filter(function (line) {
            if (!line.discountId) {
                return true;
            }
            return !mappedAvailableLoyaltyDiscounts.get(line.discountId);
        });
        this.bundleCartDiscountLines = this.bundleCartDiscountLines.filter(function (line) {
            if (!line.discountId) {
                return true;
            }
            return !mappedAvailableLoyaltyDiscounts.get(line.discountId);
        });
    };
    CreatePayment.prototype.setCustomerName = function (name) {
        this.customerName = name;
    };
    CreatePayment.prototype.setEmployeeId = function (employeeId) {
        this.employeeId = employeeId;
    };
    CreatePayment.prototype.setStatus = function (status) {
        this.status = status;
    };
    /** Product: product to subtract inventory from - pricePerInventorySubtracted: $/unit/gram - inventoryToSubtract: inventory to subtract - inventorySubtractIncrement: optional amount to override what +/- does on the POS */
    CreatePayment.prototype.addProduct = function (params, giftCardParams, isExternalOrder) {
        var paymentLine = this.createPaymentLine(params, giftCardParams);
        this.addPaymentLine(paymentLine);
        var categoryId = paymentLine.categoryId;
        var paymentLineCategory = this.categories.find(function (category) { return category.id === categoryId; });
        var categoryType = paymentLineCategory ? paymentLineCategory.categoryType : null;
        if (categoryType === Category_1.CategoryType.SYSTEM_FEES) {
            return paymentLine;
        }
        if (!isExternalOrder) {
            this.applyAvailableProductDiscount(paymentLine);
        }
        return paymentLine;
    };
    CreatePayment.prototype.addTransaction = function (transaction) {
        this.transactions.push(transaction);
    };
    CreatePayment.prototype.removeTransactionAtIndex = function (index) {
        this.transactions.splice(index, 1);
    };
    CreatePayment.prototype.clear = function () {
        this.nonBundleProductLines.length = 0;
        this.bundleCartDiscountLines.length = 0;
        this.nonBundleCartDiscountLines.length = 0;
    };
    CreatePayment.prototype.setCompleteDate = function (date) {
        this.completeDate = date;
    };
    CreatePayment.prototype.availableProductDiscounts = function (productId, categoryId, automatic) {
        var _a = this, discounts = _a.discounts, timezone = _a.timezone, shouldOverrideDiscountsTimeRestrictions = _a.shouldOverrideDiscountsTimeRestrictions, customer = _a.customer, externalCustomerLoyaltyTierId = _a.externalCustomerLoyaltyTierId, remainingLoyaltyPoints = _a.remainingLoyaltyPoints, isGrowthLoyaltyActive = _a.isGrowthLoyaltyActive, flattenedCategories = _a.flattenedCategories;
        return discounts_1.availableProductDiscounts({
            allDiscounts: discounts,
            productId: productId,
            categoryId: categoryId,
            automatic: automatic,
            timezone: timezone,
            shouldOverrideDiscountsTimeRestrictions: shouldOverrideDiscountsTimeRestrictions,
            customer: customer,
            externalCustomerLoyaltyTierId: externalCustomerLoyaltyTierId,
            remainingLoyaltyPoints: remainingLoyaltyPoints,
            isGrowthLoyaltyActive: isGrowthLoyaltyActive,
            flattenedCategories: flattenedCategories,
        });
    };
    Object.defineProperty(CreatePayment.prototype, "availableCartDiscounts", {
        get: function () {
            var _this = this;
            var paymentLinesProductIds = this.nonBundleProductLines.filter(function (pl) { return pl.productId; }).map(function (pl) { return pl.productId; });
            var paymentLinesCategoryIds = this.nonBundleProductLines.filter(function (pl) { return pl.productId; }).map(function (pl) { return pl.categoryId; });
            return this.discounts.filter(function (discount) {
                var e_2, _a, e_3, _b;
                if (discount.applyType !== 'cart') {
                    return false;
                }
                // Loyalty
                if (!discounts_1.canDiscountPassLoyaltyRestriction(discount, _this.customer, _this.externalCustomerLoyaltyTierId)) {
                    return false;
                }
                // Loyalty points
                if (!discounts_1.canDiscountPassLoyaltyPointsRestriction({ discount: discount, remainingLoyaltyPoints: _this.remainingLoyaltyPoints, isGrowthLoyaltyActive: _this.isGrowthLoyaltyActive })) {
                    return false;
                }
                // Products
                var includeProductIds = discount.products.filter(function (p) { return p.type === 'include'; }).map(function (p) { return p.id; });
                if (includeProductIds.length > 0) {
                    try {
                        for (var includeProductIds_1 = __values(includeProductIds), includeProductIds_1_1 = includeProductIds_1.next(); !includeProductIds_1_1.done; includeProductIds_1_1 = includeProductIds_1.next()) {
                            var includeProductId = includeProductIds_1_1.value;
                            if (!paymentLinesProductIds.includes(includeProductId)) {
                                return false;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (includeProductIds_1_1 && !includeProductIds_1_1.done && (_a = includeProductIds_1.return)) _a.call(includeProductIds_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                // Categories
                var includeCategoryIds = [];
                var discountIncludeCategoryIds = discount.categories.filter(function (p) { return p.type === 'include'; }).map(function (p) { return p.id; });
                discountIncludeCategoryIds.forEach(function (c) {
                    _this.flattenedCategories.forEach(function (fc) {
                        if (fc.id === c) {
                            includeCategoryIds.push(fc.id);
                        }
                        else if (fc.parentCategoryId === c) {
                            includeCategoryIds.push(fc.id);
                        }
                    });
                });
                if (includeCategoryIds.length > 0) {
                    var isIncludedAtAll = false;
                    try {
                        for (var paymentLinesCategoryIds_1 = __values(paymentLinesCategoryIds), paymentLinesCategoryIds_1_1 = paymentLinesCategoryIds_1.next(); !paymentLinesCategoryIds_1_1.done; paymentLinesCategoryIds_1_1 = paymentLinesCategoryIds_1.next()) {
                            var paymentLineCategoryId = paymentLinesCategoryIds_1_1.value;
                            if (paymentLineCategoryId && includeCategoryIds.includes(paymentLineCategoryId)) {
                                isIncludedAtAll = true;
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (paymentLinesCategoryIds_1_1 && !paymentLinesCategoryIds_1_1.done && (_b = paymentLinesCategoryIds_1.return)) _b.call(paymentLinesCategoryIds_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    if (!isIncludedAtAll) {
                        return false;
                    }
                }
                // Time/Date
                if (!_this.shouldOverrideDiscountsTimeRestrictions && !discounts_1.canDiscountPassTimeRestriction(discount, _this.timezone)) {
                    return false;
                }
                return true;
            });
        },
        enumerable: true,
        configurable: true
    });
    CreatePayment.prototype.getNetworkTransferObject = function () {
        return {
            locationId: this.locationId,
            refundPaymentId: this.refundPaymentId,
            refundLoyaltyPoints: this.refundLoyaltyPoints,
            notes: this.notes,
            paymentQueueNotes: this.paymentQueueNotes,
            shiftId: this.shiftId,
            customerId: this.customerId,
            employeeId: this.employeeId,
            tendered: this.tendered,
            pennyAdjustment: this.pennyAdjustment,
            total: this.isRefund ? this.totalAllowedRefundAmount : this.total,
            status: this.status,
            paymentQueueId: this.paymentQueueId,
            paymentLines: __spread(this.paymentLineTransferObjects, this.loyaltyPaymentLines.map(function (pl) { return pl.networkTransferObject; }), this.cartDiscountLines.map(function (cdl) { return cdl.networkTransferObject; })),
            taxPaymentLines: this.buildTaxPaymentLines().map(function (tpl) { return (__assign({}, tpl)); }),
            transactions: this.getNetworkTransactionsArray,
            offlinePaymentId: this.offlinePaymentId,
            debugMetaPayment: this.debugMetaPayment(),
            completeDate: this.completeDate,
            adjustInventory: this.adjustInventory,
            overridenManager: this.overridenManager,
            paymentVerification: this.paymentVerification,
        };
    };
    CreatePayment.prototype.addCartPercentDiscount = function (percent, discountId, name) {
        var discountName = name || percent + "% off cart";
        var referenceDiscount = discountId === null
            ? undefined
            : this.getDiscount(discountId);
        if (referenceDiscount && utilities_1.isBundleDiscount(referenceDiscount)) {
            return this.addBundleDiscount({
                name: discountName,
                discountType: Discount_1.DiscountTypes.PERCENT,
                discountFixed: 0,
                discountPercentage: percent,
                referenceDiscount: referenceDiscount,
                mappedCategories: this.mappedCategories,
                payment: this,
            });
        }
        var isStackable = !this.shouldOverrideNonStackingCartDiscountValidation && referenceDiscount ? referenceDiscount.isStackable : true;
        var centValue = this.calculatePercentageDiscount(percent, undefined, isStackable);
        return this.addCartDiscount(centValue, discountId, discountName, Discount_1.DiscountTypes.PERCENT, percent, referenceDiscount);
    };
    CreatePayment.prototype.addCartFixedDiscount = function (centValue, discountId, name) {
        var discountName = name || "$" + (centValue / 100).toFixed(2) + " off cart";
        var referenceDiscount = discountId === null
            ? undefined
            : this.getDiscount(discountId);
        if (referenceDiscount && utilities_1.isBundleDiscount(referenceDiscount)) {
            return this.addBundleDiscount({
                name: discountName,
                discountType: Discount_1.DiscountTypes.FIXED,
                discountFixed: centValue,
                discountPercentage: 0,
                referenceDiscount: referenceDiscount,
                mappedCategories: this.mappedCategories,
                payment: this,
            });
        }
        return this.addCartDiscount(centValue, discountId, discountName, Discount_1.DiscountTypes.FIXED, 0, referenceDiscount);
    };
    CreatePayment.prototype.hasDuplicateCartDiscount = function (discountId) {
        return this.cartDiscountLines.some(function (line) { return line.discountId === discountId; });
    };
    CreatePayment.prototype.addLoyaltyDiscount = function (centValue) {
        var amountToApply;
        var paymentLineTotalAmount = this.nonBundledProductPaymentLines.reduce(function (acc, _a) {
            var productLineDiscountedPrice = _a.productLineDiscountedPrice;
            return acc + productLineDiscountedPrice;
        }, 0);
        var cartDiscountLineTotalAmount = this.nonBundleCartDiscountLines.reduce(function (acc, _a) {
            var discountPrice = _a.discountPrice;
            return acc + discountPrice;
        }, 0);
        var eligibleAmount = Math.round(paymentLineTotalAmount + cartDiscountLineTotalAmount);
        if (centValue > eligibleAmount) {
            amountToApply = eligibleAmount;
        }
        else if (this.customer && centValue > this.customer.creditBalance) {
            amountToApply = this.customer.creditBalance;
        }
        else {
            amountToApply = centValue;
        }
        var minAllowableCannabisDiscountedPrice = 1 * this.getTotalCannabisItemCount(this.nonBundleProductLines); // Each cannabis product must be sold at $0.01 or greater
        var subTotalAfterDiscount = eligibleAmount - amountToApply;
        var isDiscountedPriceBelowMinimum = subTotalAfterDiscount < minAllowableCannabisDiscountedPrice;
        if (isDiscountedPriceBelowMinimum) {
            amountToApply = eligibleAmount - minAllowableCannabisDiscountedPrice;
        }
        if (amountToApply) {
            var paymentLine = new CreatePaymentLine_1.CreatePaymentLine(this, _1.PaymentLineType.LOYALTY);
            paymentLine.productName = 'Loyalty';
            paymentLine.discountLoyalty = amountToApply * -1;
            this.addPaymentLine(paymentLine);
        }
    };
    CreatePayment.prototype.setOfflinePaymentId = function (offlinePaymentId) {
        this.offlinePaymentId = offlinePaymentId;
        return this.offlinePaymentId;
    };
    CreatePayment.prototype.debugMetaPayment = function () {
        var debugPayment = {
            transactions: mobx_1.toJS(this.transactions),
            getNetworkTransactionsArray: this.getNetworkTransactionsArray.map(function (trans) { return mobx_1.toJS(trans); }),
            total: this.total,
            pennyAdjustment: this.pennyAdjustment,
            totalPaid: this.totalPaid,
            totalPaidWithoutCash: this.totalPaidWithoutCash,
            nonCashTransactions: this.nonCashTransactions.map(function (trans) { return mobx_1.toJS(trans); }),
            cashTransaction: this.tendered > 0 ? mobx_1.toJS(this.cashTransaction) : 'no cash',
            remaining: this.remaining,
            change: this.change,
            subtotal: this.subTotal,
            tax: this.tax,
            totalAmount: this.totalAmount,
            cashAmount: this.cashAmount,
        };
        return JSON.stringify(debugPayment);
    };
    CreatePayment.prototype.addPaymentLine = function (paymentLine) {
        this.nonBundleProductLines.push(paymentLine);
        this.reorderPaymentLines();
    };
    CreatePayment.prototype.setNonBundleProductLines = function (paymentLines) {
        this.nonBundleProductLines = paymentLines;
    };
    CreatePayment.prototype.setAdjustInventory = function (adjustInventory) {
        this.adjustInventory = adjustInventory;
    };
    Object.defineProperty(CreatePayment.prototype, "getNetworkTransactionsArray", {
        get: function () {
            var transactionsArr = __spread(this.nonCashTransactions.map(function (transaction) { return (__assign({}, transaction)); }));
            if (this.transactions.length === 0 && this.total === 0) {
                transactionsArr.push(this.cashTransaction);
            }
            if (this.cashTransaction.amount !== 0 && this.tendered !== 0) {
                transactionsArr.push(this.cashTransaction);
            }
            return transactionsArr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "flattenedCategories", {
        get: function () {
            var categories = this.categories || [];
            var flattenedCategories = [];
            categories.forEach(function (category) {
                flattenedCategories.push(category);
                category.childCategories.forEach(function (childCategory) {
                    var clonedChildCategory = JSON.parse(JSON.stringify(childCategory));
                    clonedChildCategory.name = "> " + clonedChildCategory.name;
                    flattenedCategories.push(clonedChildCategory);
                });
            });
            return flattenedCategories;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "mappedCategories", {
        get: function () {
            var categories = this.categories || [];
            return new Map(categories.map(function (category) { return [category.id, category]; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "customer", {
        get: function () {
            if (this.customerWithHistory) {
                return this.customerWithHistory.customer;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "customersName", {
        get: function () {
            if (this.customerWithHistory) {
                return this.customerWithHistory.customer.name;
            }
            return this.customerName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "customerId", {
        get: function () {
            if (this.customer) {
                return this.customer.id;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "tendered", {
        get: function () {
            return Transaction_1.parseTotalTransactionsById(Transaction_1.PaymentTypeIds.cash, this.transactions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "pennyAdjustment", {
        get: function () {
            return this.roundedTotal - this.total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "cashAmount", {
        get: function () {
            var neededCashAmount = this.roundedTotal - this.totalPaidWithoutCash;
            if (this.isRefund) {
                return neededCashAmount;
            }
            var isCashRequired = neededCashAmount > 0;
            var newCashAmount = isCashRequired ? neededCashAmount : 0;
            return newCashAmount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "isRefund", {
        get: function () {
            return this.refundPaymentId !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "cashTransaction", {
        get: function () {
            var cashTransaction = new Transaction_1.CreateTransaction(Transaction_1.PaymentTypeIds.cash);
            cashTransaction.setAmount(this.roundedTotal - this.totalPaidWithoutCash);
            return cashTransaction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "nonCashTransactions", {
        get: function () {
            return Transaction_1.parseTransactionsWithoutId(Transaction_1.PaymentTypeIds.cash, this.transactions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "totalAmount", {
        get: function () {
            return this.cashAmount + this.totalPaidWithoutCash;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "totalAllowedRefundAmount", {
        get: function () {
            var totalAllowed = this.total + this.originalPendingRefundPaymentTotal;
            return totalAllowed < 0 ? totalAllowed : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "roundedTotalAllowedRefundAmount", {
        get: function () {
            return this.totalAllowedRefundAmount + this.pennyAdjustment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "totalPaid", {
        get: function () {
            return this.tendered + this.totalPaidWithoutCash;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "totalPaidWithoutCash", {
        get: function () {
            var transactionsWithoutCash = Transaction_1.parseTransactionsWithoutId(Transaction_1.PaymentTypeIds.cash, this.transactions);
            var totalTransactionsWithoutCash = transactionsWithoutCash.reduce(function (acc, cur) { return acc + cur.amount; }, 0);
            return totalTransactionsWithoutCash;
        },
        enumerable: true,
        configurable: true
    });
    // Remove inline discounts before calculating taxes
    CreatePayment.prototype.buildTaxPaymentLines = function () {
        var _this = this;
        return this.paymentLines.reduce(function (acc, paymentLine, index) { return __spread(acc, _this.buildTaxPaymentLinesPerPaymentLine(paymentLine, index)); }, []);
    };
    CreatePayment.prototype.buildTaxPaymentLinesPerPaymentLine = function (paymentLine, index) {
        return paymentLine.taxLines.map(function (t) { return (__assign({}, t, { productId: paymentLine.productId, paymentLineIndex: index })); });
    };
    Object.defineProperty(CreatePayment.prototype, "tax", {
        get: function () {
            var totalTaxAmount = 0;
            this.buildTaxPaymentLines().forEach(function (taxPaymentLine) {
                totalTaxAmount += taxPaymentLine.amount;
            });
            return Math.round(totalTaxAmount);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "subTotal", {
        get: function () {
            var paymentLineTotalAmount = this.paymentLines.reduce(function (acc, _a) {
                var productLineDiscountedPrice = _a.productLineDiscountedPrice;
                return acc + productLineDiscountedPrice;
            }, 0);
            var cartDiscountLineTotalAmount = this.cartDiscountLines.reduce(function (acc, _a) {
                var discountPrice = _a.discountPrice;
                return acc + discountPrice;
            }, 0);
            var subTotal = Math.round(paymentLineTotalAmount + cartDiscountLineTotalAmount);
            if (this.isRefund)
                return subTotal;
            if (subTotal <= 0)
                return this.getTotalCannabisItemCount(this.allProductPaymentLines);
            return subTotal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "totalDepositFee", {
        get: function () {
            return this.paymentLines.reduce(function (a, pl) { return (pl.depositFee || 0) + a; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    CreatePayment.prototype.getFixedCartDiscountLines = function (productPaymentLines) {
        if (!productPaymentLines) {
            return this.fixedCartDiscountLines;
        }
        var productIds = productPaymentLines.map(function (line) { return line.productId; }).filter(function (id) { return id !== null; });
        var productIdSet = new Set(productIds);
        var includedFixedCartDiscountLines = this.fixedCartDiscountLines.filter(function (line) {
            var e_4, _a;
            try {
                for (var _b = __values(line.includedPaymentLines), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var includedLine = _c.value;
                    if (productIdSet.has("" + includedLine.productId)) {
                        return true;
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return false;
        });
        return includedFixedCartDiscountLines;
    };
    Object.defineProperty(CreatePayment.prototype, "total", {
        get: function () {
            return Math.round(this.subTotal + this.tax + this.totalDepositFee);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "actualTotal", {
        get: function () {
            return (this.subTotal + this.tax + this.totalDepositFee);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "roundRemaining", {
        get: function () {
            return Math.round(this.total - this.totalPaidWithoutCash);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "roundedTotal", {
        get: function () {
            if (!this.pennyRounding) {
                return this.total;
            }
            var hasCashTransaction = !!this.transactions.find(function (transaction) { return transaction.paymentTypeId === Transaction_1.PaymentTypeIds.cash; });
            var isCashLastTransaction = this.transactions.length > 0 && this.transactions[this.transactions.length - 1].paymentTypeId === Transaction_1.PaymentTypeIds.cash;
            var isCashRemainNotRounded = (this.total - this.totalPaidWithoutCash) % 5 !== 0;
            var isMultipleTransactionWithLastCash = this.transactions.length > 1 && this.transactions[this.transactions.length - 1].paymentTypeId === Transaction_1.PaymentTypeIds.cash;
            var shouldPennyAdjustPayment = isCashLastTransaction && isCashRemainNotRounded; // has cash as the last transaction, and the remaining amount needs rounding
            if ((!this.isRefund) && isMultipleTransactionWithLastCash && isCashRemainNotRounded) {
                var newTotal = Math.round(this.roundRemaining / 5) * 5 - ((this.total - this.totalPaidWithoutCash));
                return this.actualTotal + newTotal;
            }
            if ((this.isRefund && hasCashTransaction) || (!this.isRefund && shouldPennyAdjustPayment)) {
                return Math.round(this.total / 5) * 5;
            }
            return this.total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "change", {
        get: function () {
            var change = this.totalPaid - this.roundedTotal;
            return change > 0 ? change : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "remaining", {
        get: function () {
            return (this.roundedTotal - this.totalPaid) > 0
                ? this.roundedTotal - this.totalPaid
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "hasLoyalty", {
        get: function () {
            return this.paymentLines.find(function (paymentLine) { return paymentLine.type === 'loyalty'; }) !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "canSubmit", {
        get: function () {
            // Refunds must be exact
            if (this.isRefund)
                return this.totalAllowedRefundAmount === this.totalPaid - this.pennyAdjustment;
            // Penny adjustment occurs only when there is a cash transaction.
            // If the sum of all non-cash transactions is enough to pay the rounded total, pennyAdjustment should equal to 0.
            if (this.totalPaidWithoutCash >= this.roundedTotal && this.pennyAdjustment !== 0)
                return false;
            // Can't submit less than the rounded total
            if (this.roundedTotal > this.totalPaid)
                return false;
            // Non cash transactions can not be greater than the rounded total
            if (this.totalPaidWithoutCash > this.roundedTotal)
                return false;
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "totalCannabisWeight", {
        get: function () {
            return parseFloat(this.paymentLines
                .map(function (pl) { return pl.cannabisWeight; })
                .reduce(function (a, b) { return a + b; }, 0).toFixed(2));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "giftCardPaymentLines", {
        get: function () {
            return this.paymentLines.filter(function (paymentLine) { return paymentLine instanceof CreatePaymentLine_1.CreateGiftCardPaymentLine; });
        },
        enumerable: true,
        configurable: true
    });
    CreatePayment.prototype.reorderPaymentLines = function () {
        // Remove the observer by invoking it
        if (this.paymentLinesObserver)
            this.paymentLinesObserver();
        this.nonBundleProductLines = __spread(this.nonBundledProductPaymentLines, this.loyaltyPaymentLines);
        // Reassign the re-ordered payment lines to the observer
        this.paymentLinesObserver = mobx_1.observe(this.nonBundleProductLines, this.paymentLineListener);
    };
    CreatePayment.prototype.reorderCartDiscountLines = function () {
        if (this.cartDiscountLinesObserver)
            this.cartDiscountLinesObserver();
        this.removeUnusedNonStackableCartDiscounts();
        this.nonBundleCartDiscountLines = __spread(this.fixedCartDiscountLines, this.percentCartDiscountLines);
        this.cartDiscountLinesObserver = mobx_1.observe(this.nonBundleCartDiscountLines, this.cartDiscountLineListener);
    };
    Object.defineProperty(CreatePayment.prototype, "hasNonStackableCartDiscount", {
        get: function () {
            if (this.shouldOverrideNonStackingCartDiscountValidation)
                return false;
            return this.nonBundleCartDiscountLines.filter(function (cdl) { return cdl.referenceDiscount && cdl.referenceDiscount.isStackable === false; }).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    // centValue is expected to be positive
    CreatePayment.prototype.addCartDiscount = function (centValue, discountId, name, type, percent, referenceDiscount) {
        var canAddCartDiscount = this.canAddDiscount(referenceDiscount);
        if (!this.shouldOverrideNonStackingCartDiscountValidation && !canAddCartDiscount) {
            throw new Error('This discount conflicts with another in your cart. Only one non-stackable discount can be applied at a time.');
        }
        var isStackable = !this.shouldOverrideNonStackingCartDiscountValidation && referenceDiscount ? referenceDiscount.isStackable : true;
        var discountPrice = this.adjustCartDiscountAmount(centValue, undefined, isStackable);
        var paymentLines = isStackable
            ? this.nonBundleProductLines
            : this.nonBundleProductLines.filter(function (pl) { return pl.discountPrice === 0; });
        if (!isStackable && this.nonBundleProductLines.length > 0 && paymentLines.length === 0) {
            throw new Error('This non-stackable cart discount is not applicable.');
        }
        var cartDiscountLine = new Discount_1.CartDiscountLine({
            paymentLines: paymentLines,
            productName: name,
            discountType: type,
            discountId: discountId,
            originalDiscountPrice: Math.abs(centValue) * -1,
            discountPrice: discountPrice,
            discountPercentage: percent,
            referenceDiscount: referenceDiscount,
        }, this.mappedCategories);
        var isDiscountNotApplicable = paymentLines.length > 0 && cartDiscountLine.includedPaymentLines.length === 0;
        if (!isStackable && isDiscountNotApplicable) {
            throw new Error('This non-stackable cart discount is not applicable.');
        }
        this.nonBundleCartDiscountLines.push(cartDiscountLine);
        this.reorderCartDiscountLines();
        return cartDiscountLine;
    };
    Object.defineProperty(CreatePayment.prototype, "fixedCartDiscountLines", {
        get: function () {
            return this.nonBundleCartDiscountLines.filter(function (cdl) { return cdl.discountType === Discount_1.DiscountTypes.FIXED; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "percentCartDiscountLines", {
        get: function () {
            return this.nonBundleCartDiscountLines.filter(function (cdl) { return cdl.discountType === Discount_1.DiscountTypes.PERCENT; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "allProductPaymentLines", {
        get: function () {
            return this.paymentLines.filter(function (pl) { return pl.type === _1.PaymentLineType.PRODUCT || pl.type === _1.PaymentLineType.PAYMENT_FEE; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "nonBundledProductPaymentLines", {
        get: function () {
            return this.nonBundleProductLines.filter(function (pl) { return pl.type === _1.PaymentLineType.PRODUCT || pl.type === _1.PaymentLineType.PAYMENT_FEE; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "loyaltyPaymentLines", {
        get: function () {
            return this.nonBundleProductLines.filter(function (pl) { return pl.type === _1.PaymentLineType.LOYALTY; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "paymentLineTransferObjects", {
        get: function () {
            // get total sum of all cartDiscounts from discount paymentLines
            var cartDiscountAndLoyaltyTotals = __spread(this.cartDiscountLines, this.loyaltyPaymentLines).reduce(function (acc, curr) { return acc + curr.discountPrice; }, 0);
            var accumulatedCartDiscount = 0; // accumulated sum of cartDiscountPrice for product paymentLines
            return this.allProductPaymentLines.map(function (pl, index, self) {
                accumulatedCartDiscount += pl.cartDiscountPrice; // add paymentLines cartDiscount price
                // check if this is the last product paymentLine apply the difference to the paymentLines cartDiscountPrice
                var cartDiscountPrice = pl.cartDiscountPrice;
                if (index === self.length - 1) {
                    var difference = cartDiscountAndLoyaltyTotals - accumulatedCartDiscount;
                    cartDiscountPrice = pl.cartDiscountPrice + difference;
                }
                return __assign({}, pl.networkTransferObject, { cartDiscountPrice: cartDiscountPrice });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePayment.prototype, "mappedAvailableLoyaltyDiscounts", {
        get: function () {
            var _this = this;
            var mappedLoyaltyDiscounts = new Map();
            this.discounts.forEach(function (discount) {
                if (!discount.isLoyalty && !discount.loyaltyTierId) {
                    return;
                }
                if (_this.customer && discount.loyaltyTierId && discount.loyaltyTierId !== _this.customer.loyaltyTierId) {
                    return;
                }
                mappedLoyaltyDiscounts.set(discount.id, discount);
            });
            return mappedLoyaltyDiscounts;
        },
        enumerable: true,
        configurable: true
    });
    CreatePayment.prototype.getTotalCannabisItemCount = function (lines) {
        return lines.reduce(function (acc, curr) { return (curr.complianceCategoryId ? acc + curr.units : acc); }, 0);
    };
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "companyId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "pennyRounding", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "isGrowthLoyaltyActive", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "customerName", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "shiftId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "refundPaymentId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "refundLoyaltyPoints", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "mappedDiscounts", void 0);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "discounts", null);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "categories", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "transactions", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "offlinePaymentId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "completeDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "adjustInventory", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "paymentQueueNotes", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "employeeId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "nonBundleProductLines", void 0);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "paymentLines", null);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "bundleCartDiscountLines", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "nonBundleCartDiscountLines", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "paymentQueueDiscountIds", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "timezone", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "shouldOverrideDiscountsTimeRestrictions", void 0);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "cartDiscountLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "loyaltyCartDiscountPoints", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "loyaltyProductDiscountPoints", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "loyaltyDiscountPoints", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "loyaltyTransactionPoints", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "sumOfLoyaltyPointsUsed", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "remainingLoyaltyPoints", null);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "paymentQueueId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "customerWithHistory", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "externalCustomerLoyaltyTierId", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "overridenManager", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "shouldOverrideNonStackingCartDiscountValidation", void 0);
    __decorate([
        mobx_1.observable
    ], CreatePayment.prototype, "paymentVerification", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setShiftId", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "populateFromQueue", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setRefundLoyaltyPoints", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "populateRefund", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "populateRefundTransaction", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removeEmptyTransactions", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setDiscounts", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setCategories", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setNotes", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setPaymentQueueNotes", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addCustomer", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removeCustomer", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setCustomerName", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setEmployeeId", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setStatus", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "applyAvailableProductDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addProduct", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addTransaction", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removeTransactionAtIndex", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removePaymentLine", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removeBundleCartDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removeNonBundleCartDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "clear", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setCompleteDate", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "availableCartDiscounts", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addBundleDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "removeUnusedNonStackableCartDiscounts", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addCartPercentDiscount", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addCartFixedDiscount", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "updateCartDiscounts", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "updatePercentageCartDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "updateFixedCartDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addLoyaltyDiscount", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setOfflinePaymentId", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "addPaymentLine", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setNonBundleProductLines", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setAdjustInventory", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "getNetworkTransactionsArray", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "flattenedCategories", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "mappedCategories", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "customer", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "customersName", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "customerId", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "tendered", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "pennyAdjustment", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "cashAmount", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "cashTransaction", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "nonCashTransactions", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "totalAmount", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "totalAllowedRefundAmount", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "roundedTotalAllowedRefundAmount", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "totalPaid", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "totalPaidWithoutCash", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "tax", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "subTotal", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "totalDepositFee", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "total", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "actualTotal", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "roundRemaining", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "roundedTotal", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "change", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "remaining", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "hasLoyalty", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "canSubmit", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "totalCannabisWeight", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "giftCardPaymentLines", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "reorderPaymentLines", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "reorderCartDiscountLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "hasNonStackableCartDiscount", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "fixedCartDiscountLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "percentCartDiscountLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "allProductPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "nonBundledProductPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "loyaltyPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "paymentLineTransferObjects", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setOverridenManager", void 0);
    __decorate([
        mobx_1.computed
    ], CreatePayment.prototype, "mappedAvailableLoyaltyDiscounts", null);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setExternalCustomerLoyaltyTierId", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setIsGrowthLoyaltyActive", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setPaymentQueueDiscountIds", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setTimezone", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setShouldOverrideDiscountsTimeRestrictions", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setShouldOverrideNonStackingCartDiscountValidation", void 0);
    __decorate([
        mobx_1.action
    ], CreatePayment.prototype, "setPaymentVerification", void 0);
    return CreatePayment;
}());
exports.CreatePayment = CreatePayment;
//# sourceMappingURL=CreatePayment.js.map